import { render, staticRenderFns } from "./UploaderAndFile.vue?vue&type=template&id=09194bc5"
import script from "./UploaderAndFile.vue?vue&type=script&lang=js"
export * from "./UploaderAndFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports